angular.module('qkr').controller('merchantSettingsController', merchantSettingsController);

/* eslint max-params:0 */
function merchantSettingsController($scope, $rootScope,
                                    partnerService, merchantService, merchantShadowService,
                                    messageService, merchantInfoData, imageService, FormHelper,
                                    utils, $uibModal, gettextCatalog, appConfig,
                                    systemSettingsService, $filter, APP_CONSTANT, COUNTRY,
                                    integrationSettingsService, integrationHelperService, $log) {
    $scope.saving = false;
    $scope.showReceiptFooter = false;
    $scope.defaultCurrency = '';

    const minTipping = 0.1;
    const maxTipping = 100;
    const minServiceCharge = 0.1;
    const maxServiceCharge = 100;

    $scope.isCharityMerchant = merchantService.behaviour(merchantService.merchantInfo,
        'settingsPage.showShareTaxId');
    const handleError = reason => messageService.error(reason);

    const showServiceCharge = function () {
        // old code, calling the evil behaviour,
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showServiceCharge');
    };

    const convertFormToMerchantSettingsCommand = function(form) {
        const tipObjectArrayToTipArray = function(tipObjectArray) {
            return tipObjectArray.map(tipObject => tipObject.value);
        };

        const merchantSettings = Object.assign({}, form);

        merchantSettings.coverImageUrl = imageService.stripQueryString(form.coverImageUrl);
        merchantSettings.logoUrl = imageService.stripQueryString(form.logoUrl);
        merchantSettings.acceptedTipPercentages = tipObjectArrayToTipArray(form.acceptedTipPercentages);
        merchantSettings.partnerId = form.partner;
        merchantSettings.posPartnerId = form.posPartner;
        merchantSettings.orderUpdatePartnerNotificationQueue = merchantSettings.merchantPosProperties ?
            merchantSettings.merchantPosProperties.orderUpdatePartnerNotificationQueue : null;

        return merchantSettings;
    };

    const getDefaultTipPercentagePointer = function (value, form) {
        if (value === 0) {
            return -1;
        }

        const index = form.acceptedTipPercentages.findIndex(percentage => percentage.value === value);
        return index > -1 ? index : null;
    };

    const getDefaultTipPercentage = function (index) {
        if (utils.hasNoValue(index)) {
            return null;
        }
        if (index === -1) {
            return 0;
        }
        return $scope.form.acceptedTipPercentages[index].value;
    };

    const merchantInfo = merchantInfoData;
    $scope.isMCAdmin = appConfig.isMCAdmin;
    $scope.isPartner = appConfig.isPartner;
    $scope.isVending = false;

    // Help with errors and validation
    const formHelper = new FormHelper($scope);
    $scope.maxLength = 255;
    const initForm = () => {
        const tipArrayToTipObjectArray = function(tipArray) {
            return tipArray.map(tip => {
                return { value: tip };
            });
        };

        const form = Object.assign({}, merchantInfo);
        form.logoUrl = merchantInfo.logo;
        form.coverImageUrl = merchantInfo.coverImage;
        form.storeFrontName = merchantInfo.name;
        form.businessCategory = merchantInfo.businessCategory.id;

        if (merchantInfo.partner) {
            form.partner = merchantInfo.partner.id;
            form.notificationResourceUrl = merchantInfo.notificationResourceUrl;
        }

        if (merchantInfo.options.acceptedTipPercentages) {
            form.enableTipping = true;
            form.acceptedTipPercentages =
                tipArrayToTipObjectArray(merchantInfo.options.acceptedTipPercentages);
            $scope.defaultTipPercentagePointer =
                getDefaultTipPercentagePointer(merchantInfo.options.defaultTipPercentage, form);
            form.customTipAllowed = merchantInfo.options.customTipAllowed;
        } else {
            form.enableTipping = false;
            form.acceptedTipPercentages = [];
            $scope.defaultTipPercentagePointer = -1;
            form.customTipAllowed = false;
        }

        if (merchantInfo.options.serviceChargePercentage) {
            form.enableServiceCharge = true;
            form.serviceChargePercentage = merchantInfo.options.serviceChargePercentage;
            form.serviceChargeTaxable = merchantInfo.serviceChargeTaxable;
        } else {
            form.enableServiceCharge = false;
            form.serviceChargePercentage = 0;
            form.serviceChargeTaxable = true;
        }

        if (merchantInfo.options.useCustomThankYouMessage) {
            form.useCustomThankYouMessage = true;
        } else {
            form.useCustomThankYouMessage = false;
        }
        if (merchantInfo.options.useCustomOrderReadyMessage) {
            form.useCustomOrderReadyMessage = true;
        } else {
            form.useCustomOrderReadyMessage = false;
        }

        $scope.form = form;
    };

    const validate = function () {
        $scope.errors = null;
        const errors = {};
        let valid = true;


        if ($scope.form.enableTipping) {
            let defaultIsntSet = true;

            const invalidPercentages = $scope.form.acceptedTipPercentages.filter((percentage) => {
                return percentage.value < minTipping || percentage.value > maxTipping
                    || utils.hasNoValue(percentage.value);
            });

            if (invalidPercentages.length > 0) {
                errors.acceptedTipPercentages = gettextCatalog.getString('Please enter all ' +
                    'tip percentages (between ' + minTipping + ' and ' + maxTipping + ')');
                valid = false;
            }

            const values = $scope.form.acceptedTipPercentages.map(percentage => {
                if (percentage.value === $scope.form.defaultTipPercentage) {
                    defaultIsntSet = false;
                }
                return percentage.value;
            });

            const duplicatePercentages = values.filter((elem, pos, array) => {
                return array.indexOf(elem) !== pos;
            });

            if (duplicatePercentages.length > 0) {
                errors.acceptedTipPercentages = gettextCatalog.getString('Two tip percentages ' +
                    'cannot be the same');
                valid = false;
            }

            if (defaultIsntSet) {
                $scope.form.defaultTipPercentage = 0;
            }
        } else {
            $scope.form.acceptedTipPercentages = [];
        }

        if ($scope.form.enableServiceCharge) {
            if ($scope.form.serviceChargePercentage < minServiceCharge
                || $scope.form.serviceChargePercentage > maxServiceCharge
                || utils.hasNoValue($scope.form.serviceChargePercentage)) {
                errors.serviceChargePercentage = gettextCatalog.getString('Please enter service percentage ' +
                    '(between ' + minServiceCharge + ' and ' + maxServiceCharge + ')');
                valid = false;
            }
        }

        $scope.errors = errors;
        return valid;
    };

    $scope.init = function () {
        $scope.merchantLoaded = false;
        $scope.partners = {};

        initForm();

        systemSettingsService.loadBusinessCategories()
            .then((promise) => {
                $scope.businessCategories = promise;
            })
            .catch((reason) => {
                messageService.error('loadBusinessCategories error', reason);
                $log.error(reason);
            });

        // new integration settings
        const flattenData = integrationHelperService.convertServerDataToFlatten(merchantInfoData);
        const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
        $scope.isManualSKUVisible = !(integrationDetails.isComtrex || integrationDetails.isQuadranet);
        $scope.isServiceChargeVisible = !integrationDetails.isPos && showServiceCharge();
        // end new integration settings method

        $scope.defaultCurrency = merchantInfo.defaultCurrency;
        $scope.merchantId = merchantInfo.id;

        $scope.showReceiptFooter = (merchantInfo.contactDetails !== undefined
        && merchantInfo.contactDetails.country.isoCode.toLowerCase() === COUNTRY.COLOMBIA.CODE);
        $scope.form.receiptFooter = merchantInfo.receiptFooter;
        if (merchantInfo.partner) {
            $scope.form.partner = merchantInfo.partner.id;
            $scope.form.notificationResourceUrl = merchantInfo.notificationResourceUrl;
        }
            

        if (merchantInfo.businessCategory.name === APP_CONSTANT.BusinessCategory.VENDING
            && ($scope.isMCAdmin || $scope.isPartner)) {
            $scope.isVending = true;
            merchantShadowService.show(merchantInfo.id).then(response => {
                $scope.form.vendingQueueUrl = response.data.queueUrl;
            }).catch($log.error);
        }

        if ($scope.isMCAdmin) {
            partnerService.listPartners().then((partners) => {
                $scope.partners = partners;
                $scope.partners = $filter('orderBy')($scope.partners, 'name');
            }).catch($log.error);
        }
        $scope.dropdownAlphanumeric = [
            {name: ($filter('translate')(APP_CONSTANT.ALPHANUMERIC)), value: APP_CONSTANT.ALPHANUMERIC},
            {name: ($filter('translate')(APP_CONSTANT.NUMERIC)), value: APP_CONSTANT.NUMERIC}
        ];
    };

    $scope.editImage = function (imageId, $files) {
        imageService.editingImageId = imageId;
        if (imageId === 'cover') {
            $scope.selectImageModal(2.664, 666, '' + imageId + '' + Math.random(), $files); // Wide-image
        } else {
            $scope.selectImageModal(1, 250, '' + imageId + '' + Math.random(), $files); // Logo
        }
    };

    /*
     * Function to open the choose image modal dialog
     */
    $scope.selectImageModal = function (ratio, absoluteSize, imageName, $files) {
        imageService.editingImageReferenceName = imageName;
        $rootScope.requiredAspectRatio = ratio;
        $rootScope.scaledWidthAbsolute = absoluteSize;

        const modalInstance2 = $uibModal.open({
            template: require('../../templates/imageUpload.html'),
            controller: 'ImageController',
            windowClass: 'modal-image modal-borderless draggable',
            size: 'sm',
            backdrop: 'static',
            resolve: {
                inputImage() {
                    return $files;
                }
            }
        });

        modalInstance2.result.then((selectedItem) => {
            if (selectedItem !== 'cancel') {
                const editingImageId = imageService.editingImageId;

                if (editingImageId === 'cover') {
                    $scope.form.coverImageUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();
                } else {
                    $scope.form.logoUrl = selectedItem.mediaValue + '?decache=' + new Date().getTime();
                }

                const merchantSettings = convertFormToMerchantSettingsCommand($scope.form);

                merchantService.updateSettings(merchantSettings)
                    .then($scope.saveMerchantSettingsCallback)
                    .catch($scope.saveMerchantSettingsCallback);
            }
        }).catch($log.error);
    };

    $scope.showOrderReadySettings = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showOrderReadySettings');
    };

    $scope.showTipping = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showTipping');
    };

    $scope.showHomeDelivery = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showHomeDelivery');
    };

    $scope.showShareTaxId = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showShareTaxId');
    };

    $scope.isMerchantRegistrationRequired = function () {
        return merchantService.behaviour($rootScope.merchantInfo,
            'settingsPage.showMerchantRegistrationAsRequired');
    };

    $scope.showSaveButton = function () {
        if ($scope.isVending && !$scope.form.vendingQueueUrl) {
            return false;
        } else {
            return true;
        }
    };
    $scope.restrictNameChange = function () {
        const flattenData = integrationHelperService.convertServerDataToFlatten(merchantInfoData);
        const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
        return integrationDetails.isPos && !$scope.isMCAdmin;
    };

    $scope.addTipPercentage = function () {
        $scope.form.acceptedTipPercentages.push({});
    };

    $scope.removeTipPercentage = function(index) {
        if ($scope.defaultTipPercentagePointer === index) {
            $scope.defaultTipPercentagePointer = null;
        }
        $scope.form.acceptedTipPercentages.splice(index, 1);
    };

    $scope.showMerchantRegistrationId = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showMerchantRegistrationId');
    };

    $scope.showCostCenter = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showCostCenter');
    };

    $scope.showProfileValidation = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showProfileValidation');
    };

    $scope.showSubsidisedProduct = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showSubsidisedProduct');
    };

    $scope.showBeneficiaryAllowance = function () {
        return merchantService.behaviour($rootScope.merchantInfo, 'settingsPage.showBeneficiaryAllowance');
    };

    $scope.resetSubsidisedSection = function () {
        $scope.form.enableSubsidisedProduct = false;
        $scope.form.beneficiaryDailyAllowance = '';
    };

    $scope.resetBeneficiaryAllowance = function () {
        $scope.form.beneficiaryDailyAllowance = '';
    };

    $scope.resetNotificationResource = function () {
        $scope.form.notificationResourceUrl = '';
    };

    $scope.saveMerchantSettings = function(inValid) {
        if(inValid) {
            return;
        }

        $scope.form.defaultTipPercentage = getDefaultTipPercentage($scope.defaultTipPercentagePointer);
        if (!validate()) {
            return;
        }

        const merchantSettings = convertFormToMerchantSettingsCommand($scope.form);

        merchantService.updateSettings(merchantSettings).then((promise) => {
            if ($scope.isVending) {
                merchantShadowService.update(merchantInfo.id, merchantSettings);
            }
            $scope.saveMerchantSettingsCallback(promise);
        }).catch(handleError);

        $scope.saving = true;
    };

    // Handle the server response
    $scope.saveMerchantSettingsCallback = function (promise) {
        const response = promise;
        if (formHelper.handleResponse(response).isSuccess()) {
            $scope.saving = false;
            messageService.saveAlert();

            // Update merchant info in cache for dashboard
            merchantService.refreshMerchantInfo();

            // Reload the dashboard info
            $rootScope.$broadcast('merchantInfoChanged');

            // clear temp value
            delete $scope.form.collectionEnabled_org;
        } else {
            // An error has occurred, re-enable the button
            $scope.saving = false;
            let errorReason = {};
            if (response.data && response.data.exception) {
                errorReason = {
                    message: response.data.exception
                };
            }
            messageService.error(errorReason);
        }
    };
    // Clear the TYM if none desired
    $scope.togglePurchaseThankYouMessage = function () {
        if (!$scope.form.useCustomThankYouMessage) {
            $scope.form.purchaseThankYouMessage = '';
        }
    };

    // Clear the ORM if none desired
    $scope.toggleOrderReadyMessage = function () {
        if (!$scope.form.useCustomOrderReadyMessage) {
            $scope.form.orderReadyMessage = '';
        }
    };

    $scope.enableTipping = function () {
        if ($scope.form.enableTipping) {
            $scope.form.enableTipping = true;
            $scope.form.acceptedTipPercentages = [{value: null}];
            $scope.defaultTipPercentagePointer = -1;
            $scope.form.customTipAllowed = false;
        } else {
            $scope.form.enableTipping = false;
            $scope.form.acceptedTipPercentages = [];
            $scope.defaultTipPercentagePointer = null;
            $scope.form.customTipAllowed = false;
        }
    };

    $scope.enableServiceCharge = function () {
        if ($scope.form.enableServiceCharge) {
            $scope.form.enableServiceCharge = true;
            $scope.form.serviceChargePercentage = 0;
            $scope.form.serviceChargeTaxable = true;
        } else {
            $scope.form.enableServiceCharge = false;
            $scope.form.serviceChargePercentage = 0;
            $scope.form.serviceChargeTaxable = true;
        }
    };

    $scope.enableHomeDelivery = function () {
        if ($scope.form.homeDeliveryEnabled) {
            const modalInstance = $uibModal.open({
                template: require('../../templates/common/modalDialog.html'),
                controller: 'commonModalDialogController',
                windowClass: 'fade',
                backdrop: 'static',
                resolve: {
                    title() {
                        return gettextCatalog.getString('Home Delivery');
                    },
                    confirmButtonName() {
                        return 'OK';
                    },
                    confirmMsg() {
                        return gettextCatalog.getString('By turning off home delivery at the merchant level,' +
                            ' home delivery will be disabled for all merchant outlets. Do you want to continue?');
                    },
                    multiMsgArray() {
                        return [];
                    }
                }
            });

            modalInstance.result.then((res) => {
                if (res === 'cancel') {
                    $scope.form.homeDeliveryEnabled = true;
                }
            }, () => {
            }).catch($log.error);
        }
    };

    // Need this coz weird data binding stuff
    $scope.setDefaultTipPercentagePointer = function (index) {
        $scope.defaultTipPercentagePointer = index;
    };

    // Beneficiary Daily Allowance amount should greater than 0.00
    $scope.validateDailyBeneficiary = function () {
        return (!$scope.form.enableSubsidisedProduct
        || ($scope.form.enableSubsidisedProduct && $scope.form.beneficiaryDailyAllowance > 0))
    }
}



// WEBPACK FOOTER //
// ./src/controllers/merchant/merchant.settings.controller.js